
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
} from "@/components/ui/sidebar";
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { SidebarHeader } from "./SidebarHeader";
import { SidebarMenuItems } from "./SidebarMenuItems";

export function AppSidebar() {
  const location = useLocation();
  const [activeItem, setActiveItem] = useState("");

  useEffect(() => {
    // Extract the base path without parameters
    const path = location.pathname.split('/')[1] || "dashboard";
    
    // Map the path to menu items
    if (path === "") {
      setActiveItem("dashboard");
    } else if (path === "patient") {
      setActiveItem("queue"); // When viewing a patient, keep queue highlighted
    } else {
      setActiveItem(path);
    }
  }, [location]);

  return (
    <Sidebar>
      <SidebarHeader />
      <SidebarContent>
        <SidebarGroup>
          <SidebarGroupLabel>Menu</SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenuItems 
              activeItem={activeItem} 
              setActiveItem={setActiveItem} 
            />
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
    </Sidebar>
  );
}
